<template>
    <div>
        <Select v-model="item.val1" placeholder="请选择" @on-change="judgeFn" filterable class="sel">
            <Option v-for="(item,index) in typeSel" :key="index" :value="item.hid">{{item.hname}}</Option>
        </Select>
        <span>=</span>
        <Input v-model="item.val2" @on-change="judgeFn" class="ope"></Input>
        <span>:</span>
        <CheckboxGroup v-model="item.arr" @on-change="judgeFn">
            <Checkbox  v-for="(item,index) in typeSel" class="list" :key="index" :label="item.hid">{{item.hname}}</Checkbox>
        </CheckboxGroup>
        <!-- <Button @click="addFn"><Icon type="plus-circled" size="18" color="#2d8cf0"></Icon></Button> -->
    </div>
</template>
<script>
    export default{
        props:['msg'],
        data(){
            return{
                item:{
                    val1:'',
                    val2:'',
                    arr:[],
                },
                typeSel:[],
                checkAllGroup:[],
            }
        },
        created(){
            this.getSetDataFn();
        },
        methods:{
            judgeFn(){
                if(this.item.val1 == '' || this.item.val2 == ''){
                    return false;
                }
                for(var i=0; i<this.item.arr.length; i++){
                    if(this.item.arr[i] == ''){
                        return false;
                    }
                }
                var str = this.item.val1 +'='+this.item.val2 +':';
                var arr='';
                if(this.item.arr.length == 1){
                    str += this.item.arr[0];
                }else{
                    for(var i=0; i<this.item.arr.length; i++){
                        if(i != this.item.arr.length-1){
                            arr += this.item.arr[i] + ',';
                        }else{
                            arr += this.item.arr[i]
                        }
                    }
                    str+=arr;
                }
                this.msg.textid = str;
            },
            deleatFn(index){
                if(!(this.item.arr.length <= 1)){
                    this.item.arr.splice(index,1);
                    this.judgeFn();
                }else{
                    this.$Notice.warning({
                        title:'删除选项',
                        desc:'最后一项了不能再删除了'
                    });
                }
            },
            // addFn(){
            //     this.item.arr.push('');
            //     this.msg.textid = '';
            // },
            getSetDataFn(){
                var _this=this;
                this.$http.get('/web/template/getHeadByTemid',{
                    params:{
                        temid:_this.$route.query.temid
                    }
                }).then(function(res){
                    if(res.success){
                        _this.typeSel=res.data
                    }else{
                        _this.$Notice.error({
                            title:'获取规则下拉',
                            desc:'获取下拉失败'
                        });
                    }
                }).catch(function(){
                    _this.$Notice.error({
                        title:'获取规则下拉',
                        desc:'获取规则下拉失败'
                    });
                });
            },
        }
    }
</script>
<style scoped>
    .sel{
        width:200px;
    }
    .ope{
        width:65px;
    }
    .box{
        position:relative;
    }
    .box i{
        position:absolute;
        right:0;
        top:0;
        z-index:10;
    }
    .list{
        display:block;
        border:1px solid #e9eaec;
        margin-bottom:-1px;
        padding:5px 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/template/rule/three.vue